import {BloodGridActions} from "../redux_constants/bloodGrid.constant";

export const reset = () => ({
    type : BloodGridActions.BLOOD_FILTER_DEFAULT,
  });

export const bloodClassChanged = (value) => ({
    type : BloodGridActions.BLOOD_CLASS_CHANGED,
    response: value
  });

export const bloodAnnoStopMove = () => ({
    type : BloodGridActions.BLOOD_ANNO_STOP_MOVE,
});

export const updateSummary = (value) => ({
    type : BloodGridActions.BLOOD_ANNO_UPDATE_SUMMARY,
    response: value,
})

export const updatePage = (value) => ({
    type: BloodGridActions.UPDATE_PAGE,
    response: value
})
